// extracted by mini-css-extract-plugin
var _1 = "IedRd";
var _2 = "AWoDB";
var _3 = "GMw0f";
var _4 = "uFFRD";
var _5 = "mphRy";
var _6 = "tLzKU";
var _7 = "BHAWx";
var _8 = "IsMFl";
var _9 = "Rio09";
var _a = "YuZdB";
var _b = "jhFLj";
var _c = "Ne04t";
var _d = "renB9";
var _e = "Ufxj1";
var _f = "tiY3f";
var _10 = "FymoC";
var _11 = "Bwm7r";
var _12 = "zKTx8";
var _13 = "oAuwE";
var _14 = "Mre0c";
var _15 = "TMNyH";
var _16 = "d3ZjD";
var _17 = "Ab6_p";
export { _1 as "amount", _2 as "branding", _3 as "close-button", _4 as "department-name", _5 as "header--menu-open", _6 as "icon", _7 as "initials", _8 as "item", _9 as "load-more-button", _a as "load-more-button-icon", _b as "logo", _c as "logo-with-initials", _d as "menu-button", _e as "menu-icon", _f as "navigation", _10 as "navigation--collapsed", _11 as "navigation--mobile", _12 as "scrollable", _13 as "selected", _14 as "sub-item", _15 as "sub-items", _16 as "subtitle", _17 as "title" }
